import { API_URL } from "@/misc/constants";
import { get, post } from "./index";
import type {
  iTinkoffIndividualsBindPayoutCardDto,
  iTinkoffIndividualsBindPayoutCardRes,
  iTinkoffIndividualsGetPayoutCardsArgs,
  iTinkoffIndividualsGetSupportedSbpMembersRes,
  iTinkoffIndividualsRemovePayoutCardDto,
  tTinkoffIndividualsGetPayoutCardsRes,
} from "@/types";
import sortBy from "lodash/sortBy";

const BASE = `${API_URL}/safedeal`;
const TI_BASE = `${BASE}/tinkoffIndividuals`;

export const SafedealAPI = {
  tinkoffIndividuals: {
    async getSupportedSbpMembers() {
      const { data } = await get<iTinkoffIndividualsGetSupportedSbpMembersRes>(
        `${TI_BASE}/supportedSbpMembers`,
        {
          cache: false,
        }
      );
      return {
        ...data,
        members: sortBy(data.members, "name_ru"),
      };
    },
    async bindPayoutCard(body: iTinkoffIndividualsBindPayoutCardDto) {
      const { data } = await post<iTinkoffIndividualsBindPayoutCardRes>(
        `${TI_BASE}/bindPayoutCard`,
        body
      );
      return data;
    },
    async removePayoutCard(body: iTinkoffIndividualsRemovePayoutCardDto) {
      const { data } = await post<void>(`${TI_BASE}/removePayoutCard`, body);
      return data;
    },
    async getPayoutCards(params: iTinkoffIndividualsGetPayoutCardsArgs) {
      const { data } = await get<tTinkoffIndividualsGetPayoutCardsRes>(
        `${TI_BASE}/payoutCards`,
        {
          params,
          cache: false,
        }
      );
      return data;
    },
  },
};
